module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c758ea533da24f3d8cbb8c50bbc292e2.png";